import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kebabCase',

})
export class KebabCasePipe implements PipeTransform {

  private static readonly camelToKebab = /([a-z])([A-Z])/g;
  private static readonly capsToCapsAndLower = /([A-Z])([A-Z][a-z])/g;

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    return value
      .replace(KebabCasePipe.camelToKebab, '$1-$2')
      .replace(KebabCasePipe.capsToCapsAndLower, '$1-$2')
      .toLowerCase();
  }
}
